function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M121.717 55.813c-1.745-.11-3.752-.412-5.331-.866a30.174 30.174 0 01-1.841-.674c-5.511-2.531-9.347-8.075-9.347-14.485 0-8.803 7.214-15.983 16.076-15.983 8.792 0 15.951 7.056 16.075 15.75h5.802c-.125-11.885-9.886-21.514-21.877-21.514-12.074 0-21.89 9.753-21.89 21.747 0 8.267 4.679 15.461 11.533 19.134 1.232.647 3.018 1.32 3.614 1.5 1.952.577 4.347.962 6.48 1.127.72.055 3.254.083 3.987.083H165v-5.75h-39.918c-.527-.014-2.853-.041-3.365-.069zm3.365-9.023c-.416 0-2.631-.014-3.047-.041-.692-.055-1.689-.166-2.34-.303-.733-.193-1.412-.454-1.717-.619a6.842 6.842 0 01-3.627-6.039c0-3.796 3.101-6.877 6.923-6.877a6.894 6.894 0 016.909 6.657h5.58c-.111-6.753-5.663-12.2-12.489-12.2-6.909 0-12.517 5.557-12.517 12.42 0 4.842 2.797 9.024 6.854 11.073.623.358 1.8.743 2.132.826 1.149.302 2.686.509 3.946.591.457.041 2.728.055 3.213.055v.014H165v-5.543h-39.918v-.014zm-35.114 14.8V23.806h-8.543V18h14.4v43.59h-5.857zM75 26.708v5.585h6.425V61.59h5.621V26.707H75z",
  fill: "#E60000"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M154.685 18.399c-2.105 0-3.85 1.664-3.85 3.769 0 2.09 1.745 3.824 3.85 3.824a3.82 3.82 0 003.849-3.824c0-2.09-1.675-3.769-3.849-3.769zm0 6.974c-1.745 0-3.24-1.362-3.24-3.205 0-1.76 1.495-3.15 3.24-3.15 1.744 0 3.226 1.39 3.226 3.15.014 1.857-1.482 3.205-3.226 3.205z",
  fill: "#E60000"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M156.152 23.2c0-.427-.055-.812-.553-.963.609-.207.664-.606.664-.853 0-.977-.886-1.1-1.246-1.1h-1.675v3.768h.706v-1.554h.554c.789 0 .858.357.858.701 0 .647 0 .757.152.853h.707c-.167-.151-.111-.275-.167-.853zm-1.287-1.238h-.831v-1.197h.706c.485 0 .817.151.817.605.014.248-.111.591-.692.591z",
  fill: "#E60000"
});

var Svg1C = function Svg1C(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 240 80",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg1C, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1c.0cc04d9d.svg";
export { ForwardRef as ReactComponent };